<template>
    <layout-page title="Hubspot Semi!">
        <!-- title -->
        <div class="bg-green px-4 sm:px-6 py-4 md:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center">
            <h1 class="text-2xl md:text-4xl font-semibold text-white">Hilfe</h1>
        </div>

        <div class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-6">
            <h2 class="text-2xl font-semibold">Wie können wir Ihnen helfen?</h2>

            <div class="rounded-xl bg-white shadow">


            </div>
        </div>

<div class="leadinModal"><div class="leadinModal-content">
        <!-- hubspot copy and paste -->
<form method="post" id="hsPopUpForm-8d52a259-7726-4062-a376-64c74dbfc0ec" data-form-id="8d52a259-7726-4062-a376-64c74dbfc0ec" data-portal-id="7079844" enctype="multipart/form-data" target="target_iframe_8d52a259-7726-4062-a376-64c74dbfc0ec" action=https://forms.hubspot.com/submissions/v3/public/submit/formsnext/multipart/7079844/8d52a259-7726-4062-a376-64c74dbfc0ec accept-charset="utf-8" novalidate="novalidate" class="leadin-form-wrapper" data-hs-cf-bound="true">
<div class="leadin-input-wrapper form-fields">
<div class="leadin-input-wrapper">
<label for="input-email-8d52a259-7726-4062-a376-64c74dbfc0ec">
Meine E-Mail-Adresse
<span class="error-text"></span>
<span class="mailcheck-suggestion"></span>
<input name="email" type="email" id="input-email-8d52a259-7726-4062-a376-64c74dbfc0ec" value="" class="input-email">
<a class="leadin-resubscribe-link"></a>
<span class="resubscribe-check"></span>
</label>
</div>
<div class="leadin-input-wrapper">
<label for="input-n100t_f_weizen_ernte_22_frei_fuhre_basis_sept_mai-8d52a259-7726-4062-a376-64c74dbfc0ec">
<input name="n100t_f_weizen_ernte_22_frei_fuhre_basis_sept_mai" type="checkbox" id="input-n100t_f_weizen_ernte_22_frei_fuhre_basis_sept_mai-8d52a259-7726-4062-a376-64c74dbfc0ec" class="input-n100t_f_weizen_ernte_22_frei_fuhre_basis_sept_mai">
100t F-Weizen, Ernte '22, Frei Fuhre, Basis Sept.-Mai
<span class="error-text"></span>
</label>
</div>
<div class="leadin-input-wrapper">
<label for="input-n100t_f_gerste_ernte_22_frei_fuhre_basis_sept_mai-8d52a259-7726-4062-a376-64c74dbfc0ec">
<input name="n100t_f_gerste_ernte_22_frei_fuhre_basis_sept_mai" type="checkbox" id="input-n100t_f_gerste_ernte_22_frei_fuhre_basis_sept_mai-8d52a259-7726-4062-a376-64c74dbfc0ec" class="input-n100t_f_gerste_ernte_22_frei_fuhre_basis_sept_mai">
100t F-Gerste, Ernte '22, Frei Fuhre, Basis Sept.-Mai
<span class="error-text"></span>
</label>
</div>
<div class="leadin-input-wrapper">
<label for="input-n100t_raps_ernte_22_frei_fuhre_basis_sept_mai-8d52a259-7726-4062-a376-64c74dbfc0ec">
<input name="n100t_raps_ernte_22_frei_fuhre_basis_sept_mai" type="checkbox" id="input-n100t_raps_ernte_22_frei_fuhre_basis_sept_mai-8d52a259-7726-4062-a376-64c74dbfc0ec" class="input-n100t_raps_ernte_22_frei_fuhre_basis_sept_mai">
100t Raps, Ernte '22, Frei Fuhre, Basis Sept.-Mai
<span class="error-text"></span>
</label>
</div>
<input name="hs_context" type="hidden" id="hidden-input-hscontext-8d52a259-7726-4062-a376-64c74dbfc0ec">
</div>
<span class="submission-error hide"></span>
<div class="leadin-button-wrapper">
<button type="submit" class="leadin-button leadin-button-primary leadin-primary leadin-submit">
Jetzt einsenden
</button>
</div>
</form>
        <!-- end hubspot copy and paste -->
        </div></div>
    </layout-page>
</template>

<style scoped>

element.style {
}

.leadinModal .leadinModal-content input[type=checkbox] {
    cursor: pointer;
    display: initial;
    line-height: normal;
    position: relative;
    margin-right: 0.5em;
    top: -1px;
}

.leadinModal .leadinModal-content .secondary-dismiss, .leadinModal .leadinModal-content input[type=checkbox], .leadinModal .leadinModal-content input[type=email], .leadinModal .leadinModal-content input[type=number], .leadinModal .leadinModal-content input[type=tel], .leadinModal .leadinModal-content input[type=text], .leadinModal .leadinModal-content li, .leadinModal .leadinModal-content p, .leadinModal .leadinModal-content select, .leadinModal .leadinModal-content textarea, .leadinModal .leadinModal-content ul {
    color: #666;
    font-size: 1em;
    font-weight: 400;
}

.leadinModal .leadinModal-content h1, .leadinModal .leadinModal-content h2, .leadinModal .leadinModal-content h3, .leadinModal .leadinModal-content h4, .leadinModal .leadinModal-content h5, .leadinModal .leadinModal-content h6, .leadinModal .leadinModal-content input, .leadinModal .leadinModal-content li, .leadinModal .leadinModal-content option, .leadinModal .leadinModal-content p, .leadinModal .leadinModal-content select, .leadinModal .leadinModal-content ul {
    line-height: 1.5;
    text-transform: none;
    letter-spacing: 0;
    margin: 0;
}

.leadinModal, .leadinModal *, .leadinModal :after, .leadinModal :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 0;
    margin: 0;
    padding: 0;
}
[type="checkbox"] {
    border-radius: 0px;
}
[type="checkbox"], [type="radio"] {
    -webkit-print-color-adjust: exact;
    --tw-shadow: 0 0 #0000;
    appearance: none;
    background-color: rgb(255, 255, 255);
    background-origin: border-box;
    border-color: rgb(117, 117, 117);
    border-width: 1px;
    color: rgb(37, 99, 235);
    display: inline-block;
    flex-shrink: 0;
    height: 1rem;
    padding: 0px;
    user-select: none;
    vertical-align: middle;
    width: 1rem;
}
button, input, optgroup, select, textarea {
    color: inherit;
    font-family: inherit;
    font-size: 100%;
    line-height: inherit;
    margin: 0px;
    padding: 0px;
}
*, ::after, ::before {
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59,130,246,0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia: ;
}
*, ::after, ::before {
    border: 0px solid rgb(223, 223, 222);
    box-sizing: border-box;
}
user agent stylesheet
input[type="checkbox" i] {
    background-color: initial;
    cursor: default;
    appearance: auto;
    box-sizing: border-box;
    margin: 3px 3px 3px 4px;
    padding: initial;
    border: initial;
}
user agent stylesheet
input {
    writing-mode: horizontal-tb !important;
    font-style: ;
    font-variant-ligatures: ;
    font-variant-caps: ;
    font-variant-numeric: ;
    font-variant-east-asian: ;
    font-weight: ;
    font-stretch: ;
    font-size: ;
    font-family: ;
    text-rendering: auto;
    color: -internal-light-dark(black, white);
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    appearance: auto;
    -webkit-rtl-ordering: logical;
    cursor: text;
    background-color: -internal-light-dark(rgb(255, 255, 255), rgb(59, 59, 59));
    margin: 0em;
    padding: 1px 2px;
    border-width: 2px;
    border-style: inset;
    border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
    border-image: initial;
}

.leadinModal .leadin-input-wrapper label {
    display: block;
    font-weight: 600;
    padding-top: 0.8em;
    font-size: 1em;
    float: none;
}

.leadinModal .leadinModal-content label {
    color: #666;
}

.leadinModal-reset button, .leadinModal-reset div, .leadinModal-reset form, .leadinModal-reset h1, .leadinModal-reset h2, .leadinModal-reset h3, .leadinModal-reset h4, .leadinModal-reset h5, .leadinModal-reset h6, .leadinModal-reset img, .leadinModal-reset label, .leadinModal-reset p, .leadinModal-reset span {
    color: inherit;
    text-decoration: none;
}

.leadinModal-reset a, .leadinModal-reset button, .leadinModal-reset div, .leadinModal-reset form, .leadinModal-reset h1, .leadinModal-reset h2, .leadinModal-reset h3, .leadinModal-reset h4, .leadinModal-reset h5, .leadinModal-reset h6, .leadinModal-reset img, .leadinModal-reset label, .leadinModal-reset p, .leadinModal-reset span {
    background: none 0 0 auto repeat scroll padding-box transparent;
    background-color: transparent;
    background-image: none;
    border: 0 none transparent;
    clear: none;
    clip: auto;
    cursor: auto;
    filter: none;
    float: none;
    height: auto;
    left: auto;
    letter-spacing: auto;
    line-height: auto;
    list-style: disc outside none;
    margin: 0;
    overflow: visible;
    padding: 0;
    page-break-after: auto;
    page-break-before: auto;
    position: static;
    transform: none;
    text-align: start;
    text-indent: auto;
    text-transform: none;
    top: auto;
    vertical-align: baseline;
    visibility: initial;
    width: auto;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    z-index: auto;
}
user agent stylesheet
label {
    cursor: default;
}

.leadinModal.leadinModal-v3 .leadinModal-content {
    font-size: 14px;
}

.leadinModal .leadinModal-content {
    *zoom: 1;
    -webkit-box-shadow: 0 0 5px rgb(0 0 0 / 25%);
    -moz-box-shadow: 0 0 5px rgba(0,0,0,.25);
    box-shadow: 0 0 5px rgb(0 0 0 / 25%);
    position: relative;
    padding: 1em 1.5em;
    margin: 0 auto;
    background: #fff;
    max-width: 100%;
    width: 30em;
    font-size: 16px;
    overflow: auto;
    max-height: 70%;
}

.leadinModal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: visible;
    -webkit-overflow-scrolling: touch;
    z-index: 9999;
    font-size: 16px;
}
body {
    line-height: inherit;
    margin: 0px;
}
style attribute {
    --vh: 10.89px;
}
html {
    font-size: 14px;
}
button, html {
    --tw-text-opacity: 1;
    color: rgb(89 89 89/var(--tw-text-opacity));
    font-weight: 400;
}
html {
    text-size-adjust: 100%;
    font-family: Barlow, Roboto, Helvetica, Arial, sans-serif;
    line-height: 1.5;
    tab-size: 4;
}

.leadinModal, .leadinModal *, .leadinModal :after, .leadinModal :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 0;
    margin: 0;
    padding: 0;
}
*, ::after, ::before {
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59,130,246,0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia: ;
}
::after, ::before {
    --tw-content: "";
}
*, ::after, ::before {
    border: 0px solid rgb(223, 223, 222);
    box-sizing: border-box;
}

.leadinModal, .leadinModal *, .leadinModal :after, .leadinModal :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 0;
    margin: 0;
    padding: 0;
}
*, ::after, ::before {
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59,130,246,0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia: ;
}
::after, ::before {
    --tw-content: "";
}
*, ::after, ::before {
    border: 0px solid rgb(223, 223, 222);
    box-sizing: border-box;
}
</style>

<script>
export default {
    data() {
        return {
            showModal: true,
        }
    },
}
</script>
